import Vue from 'vue';
import currency from './currency';
import time from './time';
import counter from './counter';

Vue.filter('currency', currency);
Vue.filter('time', time);
Vue.filter('counter', counter);

export default {};
